// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PharmacyBiAddress } from './pharmacyBiAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyBiPractice {
    'additionalId'?: string;
    'address'?: PharmacyBiAddress | null;
    'fax'?: string;
    'name'?: string;
    'npi'?: string;
    'phone'?: string;
    'taxId'?: string;
    'type'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyBiPractice>> = [
        {
            "name":     "additionalId",
            "baseName": "additionalId",
            "type":     "string"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "PharmacyBiAddress"
        },
        {
            "name":     "fax",
            "baseName": "fax",
            "type":     "string"
        },
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "taxId",
            "baseName": "taxId",
            "type":     "string"
        },
        {
            "name":     "type",
            "baseName": "type",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyBiPractice.attributeTypeMap;
    }
}
